export default __webpack_public_path__ + "static/media/KOD0046-min.06ccdf2e.webp";